export default __webpack_public_path__ + "static/media/portrait.17465e6c.png";